import ResidentRegistry from "../features/residents/components/ResidentRegistry";

export default function Residents() {
  return <ResidentRegistry />;
}
